import React, { useContext, useEffect, useMemo, useState } from 'react'
import { dateCol, strCol } from '@integec/grid-tools/lib/cols'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { CriteriaRow } from 'core/screen-util'
import { getApiTargetInfo, UtilityUnitSelection } from 'core'
import { connect } from 'react-redux'
import {
  deleteCtInspctionComments,
  updateCtInspctionComments,
  getCtInspctionComments,
  getCtInspctionType,
} from 'api/pgads.js'

import CommonScreen from 'admin/component/CommonScreen'
import { Button, Input, DatePicker, Select } from 'antd'

import {
  getEnvConfig,
  getPermitActions,
  getUnitNameMap,
  getUtilityNameMap,
} from '../core/selectors'
import { ErrorContext } from 'context'
import R from 'ramda'
const headers = [
  dateCol({
    ident: 'lastInspecDate',
    display: 'Last Inspection Date',
    isKey: true,
    width: 100,
    sortOrder: 'desc',
  }),
  strCol({
    ident: 'utility',
    display: 'Utility',
    width: 250,
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'unitId',
    display: 'Unit',
    width: 250,
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'inspectionTypeCode',
    display: 'Inspection Type Code',
    isKey: true,
    width: 300,
    sortOrder: 'asc',
  }),

  strCol({
    ident: 'description',
    display: 'Description',
    width: 500,
    sortOrder: 'asc',
    ellipsis: true,
  }),
]

const title = 'CT Inspection Unit Comments'

const CtInspUnitComment = ({
  envConfig,
  actionPermits,
  unitNameMap,
  utilityNameMap,
  targetInfo,
}) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const [inspCodeMap, setInspCodeMap] = useState({})
  const { setError } = useContext(ErrorContext)
  useEffect(
    _ => {
      getCtInspctionType(targetInfo).fork(setError, data => {
        const md = R.compose(
          R.fromPairs,
          R.map(u => [u.inspectionId, u.inspectionType])
        )(data)
        setInspCodeMap(md)
      })
    },
    [targetInfo, setError]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '150px 200px 100px 200px 100px 200px',
            gap: '10px',
          }}
        >
          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Last Inspection Date :
          </div>
          <DatePicker
            style={{ minWidth: '120px' }}
            onChange={date =>
              setInsertData({
                ...insertData,
                lastInspecDate: date.format('YYYY-MM-DD'),
                lastInspecDate2: date,
                // transDate: date,
              })
            }
            value={insertData.lastInspecDate2}
            placeholder="Last Inspection Date"
            format="MM/DD/YYYY"
            allowClear={false}
          />
          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Utility / Unit :
          </div>
          <UtilityUnitSelection
            style={{ gridColumnEnd: 'span 3' }}
            utility={insertData.utility}
            unit={insertData.unit}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unitId: value[1],
                unit: value[1].substr(3),
              })
            }}
          />

          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Inspection Code :
          </div>
          <Select
            style={{ width: '100%' }}
            value={insertData.inspectionTypeCode}
            onChange={value => {
              setInsertData({
                ...insertData,
                inspectionTypeCode: value,
              })
            }}
          >
            {Object.keys(inspCodeMap).map(k => (
              <Select.Option key={k} value={k}>
                {k}-{inspCodeMap[k]}
              </Select.Option>
            ))}
          </Select>

          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Description :
          </div>

          <Input
            style={{ width: '100%', gridColumnEnd: 'span 2' }}
            value={insertData.description}
            onChange={e => {
              setInsertData({
                ...insertData,
                description: e.target.value,
              })
            }}
          />

          <div
            style={{
              display: 'grid',
              // justifyContent: 'space-around',
              gridTemplateColumns: '100px 150px 150px auto',
              gap: '10px',
              width: '90%',
            }}
          >
            <Button type="primary" onClick={() => onAdd(true)}>
              Add
            </Button>
            <Button type="primary" onClick={() => onAdd(false)}>
              Add & Hide
            </Button>
            <Button type="danger" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </CriteriaRow>
    )
  }

  const hasWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CT_INSPECTION_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const headerWithFormatter = headers.map(h =>
    h.ident === 'utility'
      ? {
          ...h,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : h.ident === 'unitId'
      ? {
          ...h,
          choices: [],
          // dataGetter: generateDataGetter,
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : h.ident === 'inspectionTypeCode'
      ? {
          ...h,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) =>
            inspCodeMap[value] ? `${value}-${inspCodeMap[value]}` : value,
          sortIndexGetter: ({ rowData }) =>
            inspCodeMap[rowData.inspectionTypeCode] ||
            rowData.inspectionTypeCode,
        }
      : h
  )

  return (
    <CommonScreen
      // heightOffset={250}
      widthOffset={50}
      insertCompHeight={50}
      // totalWidth={700}
      isAdminScreen={false}
      withoutModify={!hasWritePermission}
      allowInsert={hasWritePermission}
      title={title}
      header={headerWithFormatter}
      saveTask={updateCtInspctionComments}
      retrieveTask={getCtInspctionComments}
      deleteTask={deleteCtInspctionComments}
      autoRetrieve
      sortOptions={headers}
      insertComp={insertEvent && hasWritePermission && insertComp}
      onInsertEvent={b => setInsertEvent(hasWritePermission && b)}
      headerRowHeight={50}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  unitNameMap: getUnitNameMap(state),
  utilityNameMap: getUtilityNameMap(state),
})

export default connect(mapStateToProps)(CtInspUnitComment)
